import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { loadingWrapper } from '../../../utils/loadingWrapper';
import { useDispatch, useSelector } from 'react-redux';
import useTag from '../../../hooks/useTag';
import { setShowCreateTagUserModal } from '../../../slice/showModalSlice';
import { hexColorRegex } from '../../../utils/constants';
import { toast } from 'react-toastify';
import { privileges } from '../../../config/role';

const CreateUserTag = ({onSuccess}) => {

    const [tagData,setTagData] = useState({
        name:"",
        type:"",
        color:"",
        extId:""
    });

    const show = useSelector((state)=>state.showModal.showCreateTagUserModal);
    const userRole = useSelector((state)=> state.user.role);
    const authorized = privileges.editingUserTags.includes(userRole);
    const dispatch = useDispatch();
    const { tagLoading, createUserTag } = useTag();

    const inputValidator = {
                name:tagData.name !== "" && tagData.name.trim().length > 0,
                type:tagData.type !== "" && tagData.type.trim().length > 0,
                color:tagData.color === "" || hexColorRegex.test(tagData.color.trim()),
            }

    const tagDataCheck = () => {
        return !(inputValidator.name 
            && inputValidator.type 
            && inputValidator.color
        );
    }


    const closeCreate = () =>{
        if(!tagLoading){
            dispatch(setShowCreateTagUserModal());
            setTagData({
                name:"",
                type:"",
                color:"",
                extId:""
            });
        }
    }

    const inputHandler = (e) => {
        const { name, value } = e.target;

        setTagData((prev)=>{return{ ...prev, [name]: value }});
    }

    const sendCreateTag = () =>{
            if(!authorized) return;
            createUserTag(
                tagData,
                (data)=>{
                    toast.success("Gruppo creato con successo");
                    onSuccess();
                    closeCreate();
                },
                (error)=>{
                    console.log("errore nella creazione del gruppo",error)
                }
            );
        }


  return (
    <Modal show={show} size="md" backdrop={tagLoading?"static":true}  onHide={tagLoading ? null : closeCreate}>
        <Modal.Header closeButton>
            <Modal.Title>Crea Gruppo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='d-flex flex-column gap-3'>
                <fieldset className='detail-fieldset flex-column gap-2 align-items-center w-100'>
                    <legend className="detail-legend">Dati Gruppo</legend>
                    <div className='d-flex flex-column gap-2 w-100'>
                        <div className='d-flex flex-column w-100'>
                            <p className="m-0">Nome</p>
                            <input
                                className={`form-control ${inputValidator.name ?"":"is-invalid"}`}
                                type="text"
                                name="name"
                                required={true}
                                value={tagData.name}
                                onChange={inputHandler}
                            ></input>
                        </div>
                        <div className='d-flex flex-column w-100'>
                            <p className="m-0">Tipo</p>
                            <input
                                className={`form-control ${inputValidator.type ?"":"is-invalid"}`}
                                type="text"
                                name="type"
                                required={true}
                                value={tagData.type}
                                onChange={inputHandler}
                            ></input>
                        </div>
                    </div>
                </fieldset>
                <fieldset className='detail-fieldset flex-column gap-2 align-items-center w-100'>
                    <legend className="detail-legend">Altro</legend>
                    <div className='d-flex w-100 gap-2'>
                        <div className='d-flex flex-column w-100 justify-content-center'>
                            <p className="m-0">Colore</p>
                            <input
                                className={`form-control ${inputValidator.color ?"":"is-invalid"}`}
                                maxLength={7}
                                type="text"
                                name="color"
                                required={true}
                                value={tagData.color}
                                placeholder='#FFFFFF'
                                onChange={inputHandler}
                            ></input>
                        </div>
                        <div className='d-flex flex-column justify-content-end mb-1'>
                            <div style={{width:"25px", height:"25px", borderRadius:"50%", backgroundColor:`${hexColorRegex.test(tagData.color.trim())? tagData.color.trim() : ""}`}}></div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <div className='d-flex gap-2'>
                <Button variant="secondary" onClick={closeCreate}>Annulla</Button>
                <Button
                    variant="primary"
                    className="btn-green"
                    disabled={tagDataCheck() || tagLoading}
                    onClick={sendCreateTag}
                >
                    {loadingWrapper(tagLoading,<>Crea Gruppo</>)}
                </Button>
            </div>
        </Modal.Footer>
    </Modal>
  )
}

export default CreateUserTag